/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGoMine.vue?vue&type=template&id=5cbe1c5a"
import script from "./popGoMine.vue?vue&type=script&lang=js"
export * from "./popGoMine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports